"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalState = void 0;
const sdk_1 = require("./@uniswap/sdk");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
var ApprovalState;
(function (ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState = exports.ApprovalState || (exports.ApprovalState = {}));
class ERC20 {
    constructor(account, token, multicall, swapContract) {
        this.swapMulticall = multicall;
        this.account = account;
        this.token = token;
        this.contract = swapContract.useTokenContract(token.address, true);
    }
    async allowance(owner, erc20) {
        var _a;
        const contract = this.swapMulticall.swapContract.useTokenContract((_a = this.token) === null || _a === void 0 ? void 0 : _a.address, false);
        const inputs = [owner, erc20];
        const res = await this.swapMulticall.useSingleCallResult(contract, "allowance", inputs);
        const allowance = res.result;
        return this.token && allowance ? new sdk_1.TokenAmount(this.token, allowance.toString()) : undefined;
    }
    getApprovalState(amount, allowance) {
        if (amount.currency === sdk_1.ETHER)
            return ApprovalState.APPROVED;
        if (!allowance)
            return ApprovalState.UNKNOWN;
        return allowance.lessThan(amount) ? ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }
    async decimals() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "decimals");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0].toString();
    }
    async totalSupply() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "totalSupply");
        const decimals = await this.decimals();
        const value = (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0].toString();
        return new bignumber_js_1.default(value).div(new bignumber_js_1.default(10).exponentiatedBy(decimals)).toString();
    }
    /**
     * 授权操作
     *
     * @param {string} spender 授权地址
     * @param {string} amount 授权数量
     * @returns
     * @memberof ERC20
     */
    async approve(spender, amount) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.approve(spender, amount, {
            from: this.account
        }));
        return result;
    }
    /**
     * 转账
     *
     * @param {string} to 地址
     * @param {string} amount 授权数量
     * @returns
     * @memberof ERC20
     */
    async transfer(to, amount) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.transfer(to, amount, {
            from: this.account
        }));
        return result;
    }
    /**
     * 增加授权额度
     *
     * @param {string} to 被授权地址
     * @param {string} amount 增加的授权数量
     * @memberof ERC20
     */
    async increaseAllowance(to, amount) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.increaseAllowance(to, amount, {
            from: this.account
        }));
        return result;
    }
    /**
     * 减少授权额度
     *
     * @param {string} to 被授权地址
     * @param {string} amount 减少的授权额度
     * @memberof ERC20
     */
    async decreaseAllowance(to, amount) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.decreaseAllowance(to, amount, {
            from: this.account
        }));
        return result;
    }
}
exports.default = ERC20;
